module.exports = __webpack_public_path__ + "img/kr-bg-top-right-new.ad90aff.png";